import moment from 'moment';

/**
 * 주 시작 요일 — 지점·그룹 스케줄 설정의 weekStartDay(DayOfWeek 이름).
 * moment 의 locale 주 시작(startOf('week'))에 기대지 않고 요일 번호(moment().day(), 일=0)로 직접 계산한다.
 */
export const DAY_OF_WEEK_INDEX = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

// 설정 화면 선택지 순서(월~일)와 라벨
export const WEEK_START_DAY_OPTIONS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
export const WEEK_START_DAY_LABEL = {
  MONDAY: '월',
  TUESDAY: '화',
  WEDNESDAY: '수',
  THURSDAY: '목',
  FRIDAY: '금',
  SATURDAY: '토',
  SUNDAY: '일',
};

/** 응답 값이 요일 이름이면 그대로, 없거나 이상하면 fallback(화면의 기존 동작) */
export const normalizeWeekStartDay = (value, fallback) =>
  typeof value === 'string' && DAY_OF_WEEK_INDEX[value.toUpperCase()] != null ? value.toUpperCase() : fallback;

/** date 가 속한 주의 첫날(00:00) */
export const startOfWeekBy = (date, weekStartDay) => {
  const day = moment(date).clone().startOf('day');
  const offset = (day.day() - DAY_OF_WEEK_INDEX[weekStartDay] + 7) % 7;
  return day.subtract(offset, 'days');
};

/** date 가 속한 주의 마지막 날(23:59:59.999) */
export const endOfWeekBy = (date, weekStartDay) => startOfWeekBy(date, weekStartDay).add(6, 'days').endOf('day');

/** date 가 속한 주의 7일 */
export const weekDatesBy = (date, weekStartDay) => {
  const start = startOfWeekBy(date, weekStartDay);
  return Array.from({ length: 7 }, (_, index) => start.clone().add(index, 'days'));
};

/**
 * 주 제목 — 한 달 안이면 'YYYY년 MM월', 달이 걸치면 'YYYY년 MM월 - MM월', 연도가 걸치면 'YYYY년 MM월 - YYYY년 MM월'.
 * 지점 주간 보기와 그룹 스케줄이 같이 쓴다.
 */
export const formatWeekTitle = (start, end) => {
  if (start.isSame(end, 'month')) return start.format('YYYY년 MM월');
  if (start.isSame(end, 'year')) return `${start.format('YYYY년 MM월')} - ${end.format('MM월')}`;
  return `${start.format('YYYY년 MM월')} - ${end.format('YYYY년 MM월')}`;
};
